import React, { useCallback, useEffect, useState } from 'react'
import { Container } from './index.styled'
import { ReactComponent as EditIcon } from '../../asserts/icon/client/physical-assessment/ic_edit.svg'
import classNames from 'classnames'
import { message } from 'antd'

export default function TextEditior({
  className = '',
  required,
  value,
  placeholder,
  onChange,
  editIcon,
  view
}) {
  const [editing, setEditing] = useState(false)
  const [editedValue, setEditedValue] = useState(value)
  const [submiting, setSubmiting] = useState(false)

  useEffect(() => {
    setEditedValue(value)
  }, [value])

  const handleKeyDown = useCallback(
    async (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        if (required && !editedValue.replace(/\s/g, '').length) {
          message.warning('Please enter a valid value!')
          return
        }
        try {
          setSubmiting(true)
          await onChange(editedValue)
        } catch (error) {
          message.error(error.message || 'Update failed!')
        } finally {
          setEditing(false)
          setSubmiting(false)
        }
      }
    },
    [editedValue, onChange]
  )

  return (
    <Container
      className={classNames({ editing }, className)}
      onClick={() => setEditing(true)}
    >
      <div className="left-section">
        {editing ? (
          <input
            className="input"
            disabled={submiting}
            type="text"
            autoFocus={true}
            value={editedValue}
            placeholder={placeholder}
            onBlur={() => setEditing(false)}
            onChange={(e) => setEditedValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        ) : (
          <div
            className={classNames('v', {
              placeholder: !value
            })}
          >
            {value || '-'}
          </div>
        )}
      </div>
      {!editing && view ==='Draft' && (editIcon || <EditIcon className="edit-icon" />)}
    </Container>
  )
}
